import React from 'react';
import { NavLink } from 'react-router';
import { lscPath } from '../routing';

export const SETTINGS_TAB_GENERAL = 'General';
export const SETTINGS_TAB_ARCHIVE_AUTOMATION = 'Archive Automation';
export const SETTINGS_TAB_LIVE_AUTOMATION = 'Live Automation';
export const SETTINGS_TAB_SCHEDULE_SOURCE = 'Schedule Source';

function tabClass({ isActive }: { isActive: boolean }): string {
  return [
    'whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors',
    isActive
      ? 'bg-primary-900/50 text-primary-200 border border-primary-700'
      : 'text-secondary-400 hover:text-white hover:bg-secondary-800',
  ].join(' ');
}

interface LscSettingsTabsProps {
  leagueId: string;
  showAutomationTabs: boolean;
}

/** Horizontal sub-nav for League Settings sections. */
const LscSettingsTabs: React.FC<LscSettingsTabsProps> = ({ leagueId, showAutomationTabs }) => {
  const base = lscPath(`/leagues/${leagueId}/settings`);

  return (
    <nav
      className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1"
      aria-label="League settings sections"
      data-testid="league-settings-tabs"
    >
      <NavLink to={base} end className={tabClass}>
        {SETTINGS_TAB_GENERAL}
      </NavLink>
      {showAutomationTabs ? (
        <>
          <NavLink to={`${base}/schedule-source`} className={tabClass}>
            {SETTINGS_TAB_SCHEDULE_SOURCE}
          </NavLink>
          <NavLink to={`${base}/archive-automation`} className={tabClass}>
            {SETTINGS_TAB_ARCHIVE_AUTOMATION}
          </NavLink>
          <NavLink to={`${base}/live-automation`} className={tabClass}>
            {SETTINGS_TAB_LIVE_AUTOMATION}
          </NavLink>
        </>
      ) : null}
    </nav>
  );
};

export default LscSettingsTabs;
